// extracted by css-extract-rspack-plugin
export default {"labelText":"labelText-1plFv","textarea":"textarea-2Hw0i","invalid":"invalid-21g0v","resizable":"resizable-11OmF"};